import React, { useState } from "react";
import { ChevronLeft } from "react-feather";
import { FaWhatsapp } from "react-icons/fa";
import { Link } from "react-router-dom"; // ✅ import Link

const QuickAccess = () => {
  const [isMinimized, setIsMinimized] = useState(false);

  return (
    <>
      {/* Slide-in Panel */}
      <div
        className={`fixed top-1/2 right-4 -translate-y-1/2 z-50 bg-white shadow-xl border rounded-lg overflow-hidden transition-all duration-500 ease-in-out ${
          isMinimized ? "w-12 h-12" : "w-72"
        }`}
        style={{
          transform: isMinimized
            ? "translateY(-50%) translateX(120%)"
            : "translateY(-50%) translateX(0)",
        }}
      >
        {isMinimized ? (
          <button
            onClick={() => setIsMinimized(false)}
            className="w-12 h-12 flex items-center justify-center bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg shadow-md"
            title="Open Quick Links"
          >
            <ChevronLeft size={20} />
          </button>
        ) : (
          <div className="p-4 relative">
            <button
              onClick={() => setIsMinimized(true)}
              className="absolute top-2 right-2 bg-red-100 hover:bg-red-600 text-white rounded-full px-3 py-1 text-xs font-bold shadow-md"
              title="Close Panel"
            >
              ❌
            </button>

            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-blue-600 to-indigo-700" />
              <div className="leading-tight">
                <p className="text-sm font-semibold text-indigo-800">
                  Teemah Smart Technology Solution
                </p>
                <p className="text-[11px] text-gray-500">
                  Unlock potential through personalized learning.
                </p>
              </div>
            </div>

            <nav className="flex flex-col gap-2 text-sm mb-4 border-t pt-3">
              <a href="#how" className="hover:text-indigo-700">📘 How it works</a>
              <a href="#why" className="hover:text-indigo-700">🌟 Why choose us</a>
              <a href="#programs" className="hover:text-indigo-700">📚 Programs</a>
              <a href="#social" className="hover:text-indigo-700">💬 Social proof</a>
            </nav>

            {/* ✅ Use Link here */}
            <Link
              to="/register-student"
              className="block w-full text-center px-3 py-2 bg-yellow-400 text-black font-semibold rounded-md hover:bg-yellow-300 shadow-sm"
            >
              Free Maths Assessment
            </Link>
          </div>
        )}
      </div>
    </>
  );
};

export default QuickAccess;
